/* __next_internal_client_entry_do_not_use__ themeNames,ThemeProvider,getTheme auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Storage } from "@faire/web--source/common/Storage";
import React, { useMemo } from "react";
// eslint-disable-next-line @faire/no-theme-provider-from-styled-components
import { ThemeProvider as StyledComponentsThemeProvider } from "styled-components";
import { DefaultTheme } from "./DefaultTheme";
export var themeNames = [
    "Faire"
];
var themes = {
    Faire: DefaultTheme
};
export var ThemeProvider = function(param) {
    var theme = param.theme, children = param.children;
    var isSSR = useIsSSR();
    var highVisTypography = !isSSR && Storage.local.getItem("HIGH_VIS_SLATE_TYPOGRAPAHY") === "true";
    var highVisLayout = !isSSR && Storage.local.getItem("HIGH_VIS_SLATE_LAYOUT") === "true";
    var highVisComponent = !isSSR && Storage.local.getItem("HIGH_VIS_SLATE_COMPONENT") === "true";
    return useMemo(function() {
        var highVisState = highVisTypography || highVisLayout || highVisComponent ? {
            typography: highVisTypography,
            layout: highVisLayout,
            component: highVisComponent
        } : undefined;
        return /*#__PURE__*/ _jsx(StyledComponentsThemeProvider, {
            theme: resolveTheme(theme, highVisState),
            children: children
        });
    }, [
        children,
        highVisComponent,
        highVisLayout,
        highVisTypography,
        theme
    ]);
};
var resolveTheme = function(theme, highVisState) {
    var resolvedTheme;
    if (typeof theme === "string") {
        resolvedTheme = getTheme(theme);
    } else {
        resolvedTheme = theme;
    }
    if (highVisState) {
        return _object_spread_props(_object_spread({}, resolvedTheme), {
            highVis: highVisState
        });
    }
    return resolvedTheme;
};
export var getTheme = function(themeName) {
    var _themes_themeName;
    return (_themes_themeName = themes[themeName]) !== null && _themes_themeName !== void 0 ? _themes_themeName : DefaultTheme;
};
